import { useTheme } from '@palmetto/palmetto-components';
import { useEffect, useState } from 'react';

export interface DsmModeSyncProps {
  children: React.ReactNode;
}

const getSystemMode = (): 'light' | 'dark' =>
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const DsmModeSync = ({ children }: DsmModeSyncProps): React.ReactElement => {
  const { theme } = useTheme();
  const [systemMode, setSystemMode] = useState<'light' | 'dark'>(getSystemMode);

  useEffect(() => {
    if (theme !== 'system') {
      return;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent): void => {
      setSystemMode(e.matches ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);

  const resolvedMode = theme === 'system' ? systemMode : theme;

  return <div data-mode={resolvedMode}>{children}</div>;
};
